import { useState, useRef, useContext, useEffect } from "react";
import axios from 'fetch/axios';
import { CartContext } from "@context/CardContext";
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useAuth } from "@context/AuthContext";
import Spinner from "@components/Spinner";

const Login = () => {
  const MySwal = withReactContent(Swal)
  const [emailValue, setEmail] = useState("");
  const passwordBoxRef = useRef(null);
  const [passwordValue, setPassword] = useState("");
  const { loadCartFromLocalStorage } = useContext(CartContext);
  const { translate } = useTranslation();
  const { lang } = useContext(LanguageCurrencyContext);
  const { openAuth, closeAuth } = useAuth();
  const [loading, setLoading] = useState(true)

  const TogglePassword = (event) => {
    event = event.target;
    event.classList.toggle("icon-EyeClosed");
    event.classList.toggle("icon-EyeOpen");
    event = event.previousElementSibling;
    if (event.toggleAttribute("type")) {
      event.type = "password";
    }
  };

  const CheckPassword = (event) => {
    setPassword(event.target.value);
    if (passwordValue) {
      passwordBoxRef.current.classList.remove("InvalidInput");
    }
  };

  const getcountries = async (reload = false) => {

    if (!localStorage.getItem('countries_arteonu') || reload) {
      try {
        const response = await axios.get(`/countries?lang=${localStorage.getItem('lang_arteonu')}`);
        localStorage.setItem('countries_arteonu', JSON.stringify(response.data));
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    }

  }

  useEffect(() => {
    getcountries()
  }, [])

  const Iniciar = async e => {
    setLoading(false)
    e.preventDefault();
    passwordBoxRef.current.classList[!passwordValue ? "add" : "remove"](
      "InvalidInput"
    );
    if (emailValue && passwordValue) {
      try {
        const res = await axios.post(
          "/users/login?lang="+lang,
          {
            email: emailValue,
            password: passwordValue,
            cart: JSON.parse(localStorage.getItem('cart') ?? '[]')
          }
        );
        setLoading(true)
        if (res.data.errors) {
          MySwal.fire({
            text: res.data.message,
            icon: 'error',
            title: 'Oops...'
          })
        } else {

        let user = {
            affiliation: res.data.affiliation,
            email: res.data.email,
            name: res.data.given_name,
            country_id: res.data.country_id,
            lastname: res.data.family_name,
            phone: res.data.phone,
            code_phone: res.data.code_phone,
            date_birth: res.data.date_birth,
            verified: 1
          }
          localStorage.setItem('user_arteonu', JSON.stringify(user));
          localStorage.setItem('token_arteonu', res.data.api_token);
          localStorage.setItem('gg', res.data.gg);

          loadCartFromLocalStorage()

          closeAuth()
          MySwal.fire({
            text: translate('login.rollback'),
            icon: 'success',
          }).finally(() => {
            window.location.reload();
          })
          
        }
      } catch (error) {
        setLoading(true)
        if (error.response && error.response.status == 400) {
            MySwal.fire({
            text: error.response.data,
            icon: 'error',
            title: 'Oops...'
          })
          return
         
        } else {
          MySwal.fire({
            text: translate('login.error3'),
            icon: 'error',
            title: 'Oops...'
          })
        }
      }
    } else {
      setLoading(true)
      MySwal.fire({
        text: translate('login.error1'),
        icon: 'error',
        title: 'Oops...'
      })
    }
  };


  return (
    <>
      {!loading && <Spinner />}

      {/* if not <> -> use className='DataBox' */}
      <label className="FormData">
        <em className="RequiredData">{translate('login.email')} </em>
        <div className="FormInput">
          <input
            placeholder={translate('login.email')}
            value={emailValue}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </label>
      {/**
       *
       * ! InvalidInput className in label-> error input style
       *
       **/}
      <label className="FormData" ref={passwordBoxRef}>
        <em className="RequiredData">{translate('login.password')}</em>
        <div className="FormInput">
          <input
            placeholder={translate('login.password')}
            type="password"
            value={passwordValue}
            onChange={CheckPassword}
          />
          <i className="InputIcon icon-EyeClosed" onClick={TogglePassword}></i>
        </div>
        <em className="InfoData">{translate('login.password_no')}</em>
      </label>
      <div className="ButtonLightMedium" onClick={Iniciar}>
        {translate('login.titleM')}
        <i className="icon-ArrowRight"></i>
      </div>
      <div className="TextColorSec">
        <em>{translate('login.forgout')} </em>
        <a onClick={() => openAuth('RestablecerPassword')} style={{ cursor: 'pointer' }}>
          <b>{translate('recovery.title')} </b>
        </a>
      </div>
    </>
  );
};

export default Login;
